export default __webpack_public_path__ + "static/media/vip-scanner.74964152.svg";